import React from 'react';
import './style.scss';

export const Textarea = ({ className, onChange = () => {}, ...props }) => (
  <textarea
    className={`textarea-default ${className}`}
    placeholder="Пожалуйста введите текст"
    maxLength={256}
    onChange={e => onChange(e.target.value, e)}
    {...props}
  />
);
